import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const RecipeDetailsDialog = ({ visible, onHide, recipeDetails }) => {
    // Helper function to ensure we always have arrays
    const ensureArray = (value) => {
        if (!value) return [];
        return Array.isArray(value) ? value : [value];
    };

    if (!recipeDetails) return null;

    return (
        <Dialog
            header={recipeDetails.title}
            visible={visible}
            onHide={onHide}
            className="recipe-detail-dialog frazza-dialog-xl"
            dismissableMask
        >
            <div className="recipe-details-container">
                <div className="recipe-details-content">
                    <div className="recipe-details-main">
                        {recipeDetails.image && (
                            <div className="recipe-image-container">
                                <img
                                    src={recipeDetails.image}
                                    alt={recipeDetails.title}
                                    className="recipe-detail-image"
                                />
                                {!recipeDetails.isCustom && (
                                    <div className="recipe-badges">
                                        {recipeDetails.vegetarian && <span className="recipe-badge vegetarian">Vegetarian</span>}
                                        {recipeDetails.vegan && <span className="recipe-badge vegan">Vegan</span>}
                                        {recipeDetails.glutenFree && <span className="recipe-badge gluten-free">Gluten Free</span>}
                                        {recipeDetails.dairyFree && <span className="recipe-badge dairy-free">Dairy Free</span>}
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="recipe-meta-panel">
                            {(recipeDetails.readyInMinutes || recipeDetails.prepTime) && (
                                <div className="recipe-meta-item">
                                    <i className="pi pi-clock meta-icon"></i>
                                    <div>
                                        <span className="meta-label">Prep Time</span>
                                        <span className="meta-value">{recipeDetails.readyInMinutes || recipeDetails.prepTime} mins</span>
                                    </div>
                                </div>
                            )}

                            {recipeDetails.servings && (
                                <div className="recipe-meta-item">
                                    <i className="pi pi-users meta-icon"></i>
                                    <div>
                                        <span className="meta-label">Servings</span>
                                        <span className="meta-value">{recipeDetails.servings}</span>
                                    </div>
                                </div>
                            )}

                            {recipeDetails.healthScore && (
                                <div className="recipe-meta-item">
                                    <i className="pi pi-heart-fill meta-icon"></i>
                                    <div>
                                        <span className="meta-label">Health Score</span>
                                        <span className="meta-value">{recipeDetails.healthScore}/100</span>
                                    </div>
                                </div>
                            )}

                            {(recipeDetails.dishTypes?.length > 0 || recipeDetails.mealType) && (
                                <div className="recipe-meta-item">
                                    <i className="pi pi-tag meta-icon"></i>
                                    <div>
                                        <span className="meta-label">Category</span>
                                        <span className="meta-value">
                                            {recipeDetails.dishTypes?.length > 0
                                                ? recipeDetails.dishTypes.join(', ')
                                                : recipeDetails.mealType}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="recipe-details-sections">
                        <div className="recipe-section ingredients-section">
                            <h3 className="section-title">
                                <i className="pi pi-list section-icon"></i>
                                Ingredients
                            </h3>
                            {recipeDetails.isCustom ? (
                                <ul className="ingredients-list fancy-list">
                                    {ensureArray(recipeDetails.ingredients).map((ingredient, index) => (
                                        <li key={index} className="ingredient-item">{ingredient}</li>
                                    ))}
                                </ul>
                            ) : (
                                <ul className="ingredients-list fancy-list">
                                    {recipeDetails.extendedIngredients?.map((ingredient, index) => (
                                        <li key={index} className="ingredient-item">
                                            {ingredient.original}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="recipe-section instructions-section">
                            <h3 className="section-title">
                                <i className="pi pi-directions section-icon"></i>
                                Instructions
                            </h3>
                            {recipeDetails.isCustom ? (
                                <div className="instructions-container">
                                    {ensureArray(recipeDetails.instructions).map((instruction, index) => (
                                        <li key={index} className="instruction-step">
                                            <span className="step-number">{index + 1}</span>
                                            <span className="step-text">{instruction}</span>
                                        </li>
                                    ))}
                                </div>
                            ) : (
                                <div className="instructions-container">
                                    {recipeDetails.analyzedInstructions && recipeDetails.analyzedInstructions.length > 0 ? (
                                        <ol className="instructions-list numbered-steps">
                                            {recipeDetails.analyzedInstructions[0].steps.map(step => (
                                                <li key={step.number} className="instruction-step">
                                                    <span className="step-number">{step.number}</span>
                                                    <span className="step-text">{step.step}</span>
                                                </li>
                                            ))}
                                        </ol>
                                    ) : (
                                        <p className="instructions-text">{recipeDetails.instructions}</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {recipeDetails.winePairing?.pairedWines && (
                        <div className="recipe-section wine-pairing">
                            <h3 className="section-title">
                                <i className="pi pi-glass section-icon"></i>
                                Wine Pairing
                            </h3>
                            <p className="wine-description">{recipeDetails.winePairing.pairingText}</p>
                            <div className="wine-list">
                                {recipeDetails.winePairing.pairedWines.map((wine, index) => (
                                    <span key={index} className="wine-badge">{wine}</span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default RecipeDetailsDialog; 